import { useCallback, useState } from "react";

import { toast } from "sonner";
import { usePocketBase } from "@/context/pocketbase-context";
import { useTranslation } from "react-i18next";

export function useUserFeedback() {
  const { pb, user } = usePocketBase();
  const { t } = useTranslation(["common"]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitUserFeedback = useCallback(
    async (feedback: string) => {
      setIsSubmitting(true);
      try {
        const data = {
          user: user?.id || "",
          feedback: feedback,
        };

        await pb.collection("feedback_reports").create(data);
        return true;
      } catch (error) {
        console.error("User feedback submission failed:", error);
        toast.error(t("common:userFeedback.errorMessage"));
        return false;
      } finally {
        setIsSubmitting(false);
      }
    },
    [t],
  );

  return {
    submitUserFeedback,
    isSubmitting,
  };
}
